exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".steps-content[data-v-88c06ed2]{margin-top:16px;min-height:200px;text-align:center}.steps-action[data-v-88c06ed2]{text-align:center;margin-top:24px}.steps-footer[data-v-88c06ed2]{padding-top:60px}.steps-footer .desc-content[data-v-88c06ed2]{text-align:left;color:rgba(0,0,0,.45)}.steps-footer .desc-content .desc-title[data-v-88c06ed2]{font-size:16px;line-height:12px}.steps-footer .desc-content .desc[data-v-88c06ed2]{font-size:14px;line-height:12px}", ""]);

// exports
